const PROJECT_PREFIX = process.env.PROJECT_PREFIX;

// project prefix can either be empty(not encouraged) or should be like /project or /project/abc,
// which means it should starts with a slash and end with a non-slash character
if(PROJECT_PREFIX === ''){
  console.warn('Warning: Using empty project prefix definition is discouraged!')
}else{
  // make sure PROJECT_PREFIX always starts with a slash
  if(PROJECT_PREFIX[0] !== '/'){
    throw new Error('project prefix should start with a slash');
  }
  if(PROJECT_PREFIX[PROJECT_PREFIX.length - 1] === '/'){
    throw new Error('project prefix should not end with as slash');
  }
}

// A multi-page application has multiple mpaConfig, you should declare new mpaConfig here
const mpaConfigs = [
  {
    title: 'API文档管理',
    name: 'document-manage-page',
    routePrefix: '/document',
    file: '../src/pages/document/index.tsx',
    template:'../templates/index.html',
  },
  {
    title: '文档展示',
    name: 'docs-page',
    routePrefix:'/docs',
    file:  '../src/pages/docs/index.tsx',
    template: '../templates/index.html',
  },
  {
    title: 'Haapi审核管理',
    name: 'admin-page',
    routePrefix: '/admin',
    file: '../src/pages/admin/index.tsx',
    template:'../templates/index.html',
  },
  {
    title: 'Haapi企业管理',
    name: 'business-page',
    routePrefix: '/business',
    file: '../src/pages/business/index.tsx',
    template:'../templates/index.html',
  },
  {
    title: 'Haapi开放场景',
    name: 'scene-page',
    routePrefix: '/openscene',
    file: '../src/pages/scene/index.tsx',
    template:'../templates/index.html',
  },
  // home page config should be put last!!!!!
  {
    title: 'Haapi接口管理',
    name: 'home-page',
    routePrefix: '',
    file: '../src/pages/home/index.tsx',
    template:'../templates/index.html',
  },
];

function checkMpaConfigs() {
  for(const config of mpaConfigs){
    if(config.routePrefix[0] !== '/'){
      throw new Error('routePrefix should starts with / for ' + config.name);
    }
  }
}

function getConfigBySpaName(name){
  return mpaConfigs.find(c=>c.name === name);
}

// get the root url for a specific spa
function getSpaUrlRootUrl(name){
  const config = getConfigBySpaName(name);
  const routePrefix = config.routePrefix;
  return PROJECT_PREFIX + routePrefix;
}

function getSpaBaseName(name){
  return getSpaUrlRootUrl(name);
}

module.exports = {
  PROJECT_PREFIX,
  mpaConfigs,
  getConfigBySpaName,
  getSpaUrlRootUrl,
  getSpaBaseName,
};
